import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function BarraCurso() {
  const local = useLocation();
  if (local.pathname !== '/loja-publica') return null;
  return (
    <div className="w-full bg-[#1E1A24] border-b border-[#E2B84A] px-4 py-3" style={{ fontFamily: 'Manrope, sans-serif' }}>
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-[#F2F0EA] text-base text-center sm:text-left">
          <b className="text-[#E2B84A]">Curso de Segurança</b> para patinetes, bikes elétricas e scooters
        </p>
        <div className="flex gap-2">
          <Link to="/curso/gratis" className="bg-[#E2B84A] text-[#141118] font-bold rounded-lg px-4 py-2">Aula grátis</Link>
          <Link to="/curso/aluno" className="border border-[#E2B84A] text-[#E2B84A] font-bold rounded-lg px-4 py-2">Área do Aluno</Link>
        </div>
      </div>
    </div>
  );
}
